module.exports = __webpack_public_path__ + "img/Injection.8c760cc.png";